import React, {useEffect, useState} from "react";

import {State,KEY_CONTEXT_TOKEN} from "./Apollo_Context"

export function ApolloGetApiToken () : string {

    const rawdata = sessionStorage.getItem(KEY_CONTEXT_TOKEN);
    if (rawdata != null) {
        const initdata: State = JSON.parse(rawdata)
        //アクセストークン取得
        return initdata.accesstoken
    }
    return ""
};

export function ApolloSetApiToken (  idtoken : string ) : Boolean {
    const rawdata = sessionStorage.getItem(KEY_CONTEXT_TOKEN);
    let ret = false
    if (rawdata != null) {
        const initdata: State = JSON.parse(rawdata)
        //アクセストークン取得
        initdata.accesstoken = idtoken
        sessionStorage.setItem(KEY_CONTEXT_TOKEN, JSON.stringify(initdata));
        ret = true
    }
    return ret
};

